module.exports = __webpack_public_path__ + "static/img/3f1a2ab59570ea9614ed6f8098fdd004.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/six_icon2.png
// module id = DXX5
// module chunks = 1